import React, {useContext} from "react";
import {Box, Skeleton, Table, TableCell, TableHeading, Text} from "@nike/eds";
import SnackbarContext from "../../providers/snackbar-context";
import './EntryContextOverview.css';
import useSWR from "swr";

export function EntryContextOverview({ inventoryService, LocationTracker }) {
    const snackbarCtx = useContext(SnackbarContext);

    const fetcher = async () => {
        try {
            const result = await inventoryService.listEntryContexts();
            return result.data.entryContextDynamicSearch.items || [];
        } catch (error) {
            const errorMessage = error instanceof Error ? error.message : "An unknown error occurred";
            snackbarCtx.displayMsg(errorMessage, "error");
            throw error;
        }
    };

    const { data: entryContexts, isLoading } = useSWR("entryContexts", fetcher, {
        refreshInterval: 60000
    });

    const headers = [
        { Header: "ID" },
        { Header: "Entry ID" },
        { Header: "Type" },
        { Header: "Delivery ID" },
        { Header: "Transport Holder ID" },
        { Header: "Bill of Lading" },
    ];

    return (
        <div>
            <Text style={{ marginBottom: "1rem", fontWeight: "bold" }} font={"display-3"} as={"h3"}>
                Entry Context
            </Text>
            <Box className="eds-grid eds-elevation--4">
                <Table>
                    <thead>
                    <tr>
                        {headers.map((column) => (
                            <TableHeading key={column.Header}>{column.Header}</TableHeading>
                        ))}
                    </tr>
                    </thead>
                    <tbody>
                    {isLoading &&
                        <tr>
                            {headers.map((_, index) => (
                                <TableCell key={index}><Skeleton height={35} width={"100%"}/></TableCell>
                            ))}
                        </tr>
                    }
                    {!isLoading && !entryContexts?.length &&
                        <tr>
                            <TableCell colSpan={6}>No entry contexts found</TableCell>
                        </tr>
                    }
                    {!isLoading && entryContexts?.length > 0 &&
                        entryContexts.map((item) => (
                            <tr key={item.id}>
                                <TableCell>{item.id}</TableCell>
                                <TableCell>{item.entryId}</TableCell>
                                <TableCell>{item.type}</TableCell>
                                <TableCell>{item.deliveryId}</TableCell>
                                <TableCell>{item.transportHolderId}</TableCell>
                                <TableCell>{item.billOfLading}</TableCell>
                            </tr>
                        ))}
                    </tbody>
                </Table>
            </Box>
            <LocationTracker location="Entry Context Overview" sublocation="Overview" />
        </div>
    );
}